var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.5C14.8995 1.5 17.25 3.85051 17.25 6.75C17.25 8.23641 16.6323 9.57854 15.6395 10.5337C18.6526 10.8529 21 13.4023 21 16.5V22.5H3V16.5C3 13.4023 5.34744 10.8529 8.36045 10.5337C7.36772 9.57854 6.75 8.23641 6.75 6.75C6.75 3.85051 9.1005 1.5 12 1.5ZM12 12H9C6.58573 12 4.61551 13.9012 4.5049 16.2882L4.5 16.5V21H19.5V16.5C19.5 14.0857 17.5988 12.1155 15.2118 12.0049L15 12H12ZM12 10.5C14.0711 10.5 15.75 8.82107 15.75 6.75C15.75 4.67893 14.0711 3 12 3C9.92893 3 8.25 4.67893 8.25 6.75C8.25 8.82107 9.92893 10.5 12 10.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.8f3cbd6bf114def58beaa818d1c0e0a8.svg";
export { ForwardRef as ReactComponent };